import React, { useContext } from 'react';
import { Progress, Typography } from 'antd';
import { getSafePercentage } from '../../utils/misc';
import { ThemeContext, ThemeContextState } from '../../context/ThemeContext';
import { DIFFICULTY_STATS_PROGRESS_COLORS } from '../../config/colors';
import styles from './DifficultyProgressStats.module.css';

export interface DifficultyProgressStatsProps {
  beginnerProblemsSolved: number
  totalBeginnerProblems: number
  intermediateProblemsSolved: number
  totalIntermediateProblems: number
  advancedProblemsSolved: number
  totalAdvancedProblems: number
};

// shows progress bars for number of
// beginner, intermeidate, and advanced
// problems solved by user
const DifficultyProgressStats = (props: DifficultyProgressStatsProps): JSX.Element | null => {
  // get current theme from theme context
  const { theme } = useContext(ThemeContext) as ThemeContextState;

  return (
    <div className={styles.mainContainer}>
      <Typography.Text className={styles.problemsSolvedText}>
        {`${props.beginnerProblemsSolved}/${props.totalBeginnerProblems} Beginner Problems Solved`}
      </Typography.Text>
      <Progress
        type='line'
        percent={getSafePercentage(props.beginnerProblemsSolved, props.totalBeginnerProblems)}
        strokeColor={{'0%': DIFFICULTY_STATS_PROGRESS_COLORS['beginner_problems_solved'].left, '100%': DIFFICULTY_STATS_PROGRESS_COLORS['beginner_problems_solved'].right}}
        trailColor={DIFFICULTY_STATS_PROGRESS_COLORS['beginner_problems_solved'].unfilled[theme]}
        format={() => ''}
      />
      <Typography.Text className={styles.problemsSolvedText}>
        {`${props.intermediateProblemsSolved}/${props.totalIntermediateProblems} Intermediate Problems Solved`}
      </Typography.Text>
      <Progress
        type='line'
        percent={getSafePercentage(props.intermediateProblemsSolved, props.totalIntermediateProblems)}
        strokeColor={{'0%': DIFFICULTY_STATS_PROGRESS_COLORS['intermediate_problems_solved'].left, '100%': DIFFICULTY_STATS_PROGRESS_COLORS['intermediate_problems_solved'].right}}
        trailColor={DIFFICULTY_STATS_PROGRESS_COLORS['intermediate_problems_solved'].unfilled[theme]}
        format={() => ''}
      />
      <Typography.Text className={styles.problemsSolvedText}>
        {`${props.advancedProblemsSolved}/${props.totalAdvancedProblems} Advanced Problems Solved`}
      </Typography.Text>
      <Progress
        type='line'
        percent={getSafePercentage(props.advancedProblemsSolved, props.totalAdvancedProblems)}
        strokeColor={{'0%': DIFFICULTY_STATS_PROGRESS_COLORS['advanced_problems_solved'].left, '100%': DIFFICULTY_STATS_PROGRESS_COLORS['advanced_problems_solved'].right}}
        trailColor={DIFFICULTY_STATS_PROGRESS_COLORS['advanced_problems_solved'].unfilled[theme]}
        format={() => ''}
      />
    </div>
  );
};

export default DifficultyProgressStats;
